import { Anchor } from '@zillow/constellation-10';
import { css } from '@/styled-system/css';
import { styled } from '@/styled-system/jsx';

export const floatingWidgetStyles = css.raw({
  bottom: 0,
  display: 'flex',
  flexDirection: 'column',
  margin: '0 20px 20px 0',
  position: 'fixed',
  right: 0,
  width: 'auto',
  zIndex: '9999',
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
  padding: '400',
});

export const StyledAnchor = styled(Anchor, {
  base: {
    color: 'text.neutral !important',
  },
});
